"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Text(props) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "span", mb: 0, mt: 0, pt: 0, pb: 0 }, props), void 0);
}
exports.Text = Text;
//# sourceMappingURL=index.js.map